import { render, staticRenderFns } from "./Page5.vue?vue&type=template&id=472a9de8&scoped=true&"
import script from "./Page5.vue?vue&type=script&lang=js&"
export * from "./Page5.vue?vue&type=script&lang=js&"
import style0 from "./Page5.vue?vue&type=style&index=0&id=472a9de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472a9de8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('472a9de8')) {
      api.createRecord('472a9de8', component.options)
    } else {
      api.reload('472a9de8', component.options)
    }
    module.hot.accept("./Page5.vue?vue&type=template&id=472a9de8&scoped=true&", function () {
      api.rerender('472a9de8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/Page5.vue"
export default component.exports